var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDryerAltRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 160a136 136 0 1 0 136 136 136 136 0 0 0 -136-136zm0 224c-40.2 0-73.7-27.2-84.3-64H176a16 16 0 0 0 16-16v-16a16 16 0 0 0 -16-16h-36.3c10.5-36.8 44.1-64 84.3-64a88 88 0 0 1 0 176zm-96-280a24 24 0 1 0 -24 24 24 24 0 0 0 24-24zm56 24a24 24 0 1 0 -24-24 24 24 0 0 0 24 24zM384 0H64A64 64 0 0 0 0 64v416a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a64 64 0 0 0 -64-64zm16 464H48V64a16 16 0 0 1 16-16h320a16 16 0 0 1 16 16z",
    fill: "#002EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryerAltRegular);
export default __webpack_public_path__ + "static/media/dryer-alt-regular.fba6f117668c1d77879efba6e889dac8.svg";
export { ForwardRef as ReactComponent };